<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2018</span></div>
    </div>
    <div class="view-wrap yr2018">

<FullYearStats fullGames='15' fullCompletions='364' fullAttempts='489' fullYards='3,992' fullPct='74.4' fullTDs='32' fullINTs='5' fullYPG='266.1' fullRating='115.7'></FullYearStats>


  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    
      <div class="year-summary-text-flex">

<h1 class="content-headline">Another Record Breaking Year</h1>

      <div class="copy-paragraph">

      New Orleans Saints quarterback Drew Brees put together one of the finest seasons of his 18-year career, leading the Saints to a 13-3 record and the No. 1 seed in the playoffs. In the process he became the NFL's all-time passing king and broke his own record for completion percentage.
      <br/><br/>

      Brees finished the 2018 season, his 13th with the Saints, with an NFL-record completion percentage (74.4 percent), and a career-high quarterback rating (115.7). He completed 364 of 489 passes for 3,992 yards, 32 touchdowns, and just five interceptions in 15 games (he was rested in the season finale vs. the Carolina Panthers).<br/><br/>

      For the third year in a row, Brees was selected to the Pro Bowl, making this his 11th season as a selection and was second team All-Pro. Brees was the NFC Offensive Player of the Month in December and was the NFC Offensive Player of the Week twice. He was the runner-up in voting for the MVP award and was the winner of the Art Rooney Sportsmanship Award<br/><br/>

      <a href="https://www.neworleanssaints.com/news/new-orleans-saints-2018-season-recap-drew-brees" class="external-link" target="_blank">READ: Drew Brees' 2018 Season Recap</a><br/><br/>

      <a href="https://www.neworleanssaints.com/video/new-orleans-saints-quarterback-drew-brees-top-10-plays-2018-season" class="external-link" target="_blank">WATCH: Drew Brees' Top 10 Plays of 2018</a><br/><br/>

      </div>

      <div class="copy-paragraph">
      <img :src="require('@/assets/brees-2018-img-in-copy.jpg')" style="width:100%;" alt="Drew Brees running off the field postgame with one of his record-breaking game-balls">
      </div>


<div class="awards-wrapper">
        <div class="awards-headline">2018 Awards</div>
        <ul>

          <li><img :src="require('@/assets/pro-bowl.png')" alt="Pro Bowl Logo"> 2018 Pro Bowl</li>
          <li><img :src="require('@/assets/nfl-logo.svg')" alt="NFL Logo"> 1st Team All-Pro (SN)</li>
          <li><img :src="require('@/assets/nfl-logo.svg')" alt="NFL Logo"> 2nd Team All-Pro (AP, PFF)</li>
          <li><img :src="require('@/assets/art-rooney-sportsmanship-award.png')" alt="Art Rooney Award Logo"> Art Rooney Sportsmanship Award</li>
          <li><img :src="require('@/assets/101-award.png')" alt="101 Awards Logo"> Committee of 101 NFC Offensive Player of the Year</li>
          <li><img :src="require('@/assets/pfwa-award.jpg')" alt="Pro Football Writers of America Logo"> PFWA All-NFC</li>

          
        </ul>
        <div class="awards-legend">
<b>AP</b> - Associated Press, <b>CN</b> - College & Pro Football Weekly, <b>FD</b> -Football Digest, <b>FN</b> -Football News, <b>FW</b> - Professional Football Writers of America, <b>NE</b> - Newspaper Enterprise Association, <b>NY</b> - New York Daily News, <b>PFWA</b> - Pro Football Writers of America, <b>PW</b> - Pro Football Weekly(1992-2012,choices combined with Pro Football Writers of America), <b>SI</b> - Sports Illustrated, <b>SN</b> - Sporting News, <b>UP</b> - United Press International, <b>UW</b> - USA Today/Sports Weekly
        </div>
      </div> 
      </div> <!--end text-flex-->
  </div>




</div>


   <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">Top Rated QBs of 2018</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
    </div>


<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2018 Touchdown Tally"> 2018 TOUCHDOWN TALLY</h1>
</div>

<TDsByYear :tds="this.tds"></TDsByYear>


<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2018 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2018 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2018 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2018 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2018 - Slide5"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image6)" alt="Drew Brees in 2018 - Slide6"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image7)" alt="Drew Brees in 2018 - Slide7"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image8)" alt="Drew Brees in 2018 - Slide8"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2017">«2017</router-link></div>
  <div class="year-pagination-section year-pagination-current">2018</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2019">2019»</router-link></div>
</div>



    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue'

import axios from 'axios';

export default {
  name: 'yr2018',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2018 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2018-jump.jpg",
      image1: "brees-2018-slide-1.jpg",
      image2: "brees-2018-slide-2.jpg",
      image3: "brees-2018-slide-3.jpg",
      image4: "brees-2018-slide-4.jpg",
      image5: "brees-2018-slide-5.jpg",
      image6: "brees-2018-slide-6.jpg",
      image7: "brees-2018-slide-7.jpg",
      image8: "brees-2018-slide-8.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2018;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },

    mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)


    },
    created() {
       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "black",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        "pointRadius": 100,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 115.7,
                  y: 74.4,
                  r: 5*2
                }
              ]
      },
      {
        "label": "Russell Wilson",
        "backgroundColor": "#69BE28",
        "borderColor": "#002244",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 110.9,
                  y: 65.6,
                  r: 7*2
                }
              ]
      },
      {
        "label": "Patrick Mahomes",
        "backgroundColor": "#FFB81C",
        "borderColor": "#E31837",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 113.8,
                  y: 66.0,
                  r: 12*2
                }
              ]
      },
      {
        "label": "Phillip Rivers",
        "backgroundColor": "#0080C6",
        "borderColor": "#FFC20E",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 105.5,
                  y: 68.3,
                  r: 12*2
                }
              ]
      },
      {
        "label": "Matt Ryan",
        "backgroundColor": "#A71930",
        "borderColor": "#000000",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 108.1,
                  y: 69.4,
                  r: 7*2
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '2018 TOP QBs (Bubble size is interceptions)'
        },
        "layout": {
          padding: {
                left: 10,
                right: 10,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel + ' COMP%, ' + tooltipItem.xLabel + ' QB RATING, ' + rLabel/2 + ' INTs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Completion Percentage'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value + '%';
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Quarterback Rating'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }
  }
}
</script>

<style>

.external-link  {
    border-bottom: 3px solid #D3BC8D;
    transition-duration: .25s;
    color:black;
    text-decoration:none;
}
.external-link:hover {
    background: #D3BC8D;
    transition-duration: .25s;
}


.year-top-image > img {
  width:100%;
}


@media (max-width:767px;) {
  .year-main-content {
  margin-top:35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/yr2018.vue